import React, { PropsWithChildren } from 'react';
import { AppShell } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import PrivateLayoutHeader from './PrivateLayout.header';
import PrivateLayoutFooter from './PrivateLayout.footer';
import PrivateLayoutNavbar from './PrivateLayout.navbar';
import classes from './private-layout.module.css';
import { HEADER_HEIGHT, NAVBAR_MOBILE_WIDTH } from '@/constants';

const PrivateLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const [opened, { toggle }] = useDisclosure();

  return (
    <AppShell
      header={{ height: HEADER_HEIGHT }}
      navbar={{
        width: NAVBAR_MOBILE_WIDTH,
        breakpoint: 'sm',
        collapsed: { desktop: true, mobile: !opened },
      }}
    >
      <AppShell.Header px="md" className={classes.header}>
        <PrivateLayoutHeader opened={opened} toggle={toggle} />
      </AppShell.Header>
      <AppShell.Navbar p="md" className={classes.navbar}>
        <PrivateLayoutNavbar toggle={toggle} />
      </AppShell.Navbar>
      <AppShell.Main>
        {children}
        <PrivateLayoutFooter />
      </AppShell.Main>
    </AppShell>
  );
};

export default PrivateLayout;
